// @flow

import * as React from 'react';
import { withI18n, Trans } from '@lingui/react';
import Img from 'gatsby-image';
import { FeatureLinks } from '../components/Features';
import { Reference } from '../components/Reference';

const Header = ({ i18n, data }: Props) => (
  <header className="header bg-ledgy pb-0">
    <div className="container" id="start">
      <div className="row align-items-end gap-y mt-5 pb-7">

        <div className="col-lg-6 ml-auto">
          <div className="mb-4 text-white">
            <h1><Trans>s1_title</Trans></h1>
            <p>
              <Trans>s1_p1</Trans>
              <br /><br />
              <Trans>s1_p2</Trans>
            </p>
          </div>
          <a className="btn btn-block d-sm-inline btn-xl mx-1 btn-round btn-outline-light" href="#references" target="_blank" rel="noopener noreferrer"><Trans>s2_title</Trans></a>
          <a className="btn btn-block d-sm-inline btn-xl mx-1 btn-round btn-light" href="#try"><Trans>s3_link</Trans></a>
        </div>

        <div className="col-lg-6 order-lg-first">
          <Img {...data.laptop} alt={i18n.t`Focus tax solutions`} />
        </div>
      </div>
    </div>
  </header>
);

const IndexPage = (props: Props) => (
  <div>
    <Header {...props} />
    <main className="main-content">
      <section className="section py-7" id="references">
        <div className="container">
          <header className="section-header mb-3">
            <h2><Trans>s2_title1</Trans></h2>
            <hr className="my-2" />
          </header>

          <div className="partner">
            <Reference img={props.data.cpa} name="cpa" />
            <Reference img={props.data.ipa} name="ipa" width="400px" />
          </div>
          <FeatureLinks {...props} page="index" />

        </div>
      </section>

    </main>
  </div>
);

export default withI18n()(IndexPage);

// eslint-disable-next-line no-undef
export const pageQuery = graphql`
  query IndexQuery {
    ...FeaturesFragment

    laptop: imageSharp(id: { regex: "/laptop.png/" }) {
      sizes(maxWidth: 2000) { ...GatsbyImageSharpSizes_noBase64 }
    }
    cpa: imageSharp(id: { regex: "/cpa.jpg/" }) {
      sizes(maxWidth: 200) { ...GatsbyImageSharpSizes_noBase64 }
    }
    ipa: imageSharp(id: { regex: "/ipa.png/" }) {
      sizes(maxWidth: 400) { ...GatsbyImageSharpSizes_noBase64 }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx